export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00871.c7f8ed69.png";